import { SpinResponse } from '@cgs/data-access';
import { CgsEvent, Container } from '@cgs/wge';
import { T_ISlotGameEngineProvider } from '../../../type_definitions';
import { ISlotGameEngineProvider } from '../../game_components_providers/i_slot_game_engine_provider';
import { ISlotGameEngine } from '../../i_slot_game_engine';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { BaseGameRule } from './infra/base_game_rule';

export class WaitAccelerationCompleteRule<
  TResponse extends SpinResponse,
> extends BaseGameRule<TResponse> {
  private _container: Container;
  private _gameEngine: ISlotGameEngine;

  constructor(
    container: Container,
    sourceState: BaseGameState<TResponse>,
    responseHolder: ResponseHolder<TResponse>
  ) {
    super(sourceState, responseHolder);
    this._container = container;
  }

  // Same hole as in WaitResponseEventRule: the inherited
  // BaseGameRule.dispatchEvent triggers on any event without checking
  // isSlotAccelerated. Route events through the guarded update() logic.
  public dispatchEvent(_event: CgsEvent): void {
    this.update(0);
  }

  public update(_dt: number): void {
    if (!this._gameEngine) {
      this._gameEngine =
        this._container.resolve<ISlotGameEngineProvider>(T_ISlotGameEngineProvider).gameEngine;
    }

    this.triggered =
      this._gameEngine.isSlotAccelerated &&
      this.ruleCondition(this.responseHolder) &&
      this.sourceState.isFinished;
  }
}
